<template>
  <!-- header start  v-if="i.name!=='大数据平台'"-->
  <div class="header-bar">
    <div class="logo"></div>
    <!-- nav start -->
    <div
      class="nav"
      v-for="(i, index) in navList"
      :key="index"
      @mouseover="mouseover(i)"
    >
      
      <router-link :to="i.path" :target="i.name =='大数据平台'? '_blank' : ''">{{ i.name }}</router-link> 
      <!-- <a :href="i.path" v-if="i.name==='大数据平台'" target="_blank">{{ i.name }}</a> -->
      <!-- 子菜单 start -->
      <div class="sub-nav" v-if="index == currentID" @mouseleave="mouseleave()">
        <!-- 说明 start -->
        <span class="sub-title">
          <h2>{{ i.name }}</h2>
          <p v-html="i.desc"></p>
        </span>
        <!-- 说明 end -->
        <!-- menu start -->
        <div class="sub-menu">
          <span
            class="sub-menu-item"
            v-for="(j, index) in i.children"
            :key="index">
            <a class="p" @click="toLink(j)">{{ j.name }}</a> 
            <p class="p">{{ j.desc }}</p>
          </span>
        </div>
        <!-- menu end -->
        <i class="sub-menu-close el-icon-close" @click="currentID = '-1'" />
      </div>
      <!-- 子菜单 end -->
    </div>
    <!-- nav end -->
  </div>
  <!-- header end -->
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      navList: [
        {
          id: "0",
          name: "首页",
          path: "/home",
          desc: "",
          children: [],
        },
        {
          id: "1",
          name: "新闻资讯",
          path: "/news",
          desc: "",
          children: [],
        },
        {
          id: "2",
          name: "冲锋衣产业链",
          path: "",
          desc: "聚合全产业链上下游优质资源 <br /> 数字化赋能传统企业转型升级",
          children: [
            {
              id:"1",
              name: "生产厂家",
              desc: "冲锋衣生产厂家详细介绍",
              path: "/ecosphere",
            },
            {
              id:"2",
              name: "销售服务商",
              desc: "冲锋衣销售服务商详细介绍",
              path: "/ecosphere",
            },
            {
              id:"3",
              name: "原料供应商",
              desc: "冲锋衣原料供应商详细介绍",
              path: "/ecosphere",
            },
            {
              id:"4",
              name: "其他服务商",
              desc: "冲锋衣其他相关服务商详细介绍",
              path: "/ecosphere",
            },
          ],
        },
        {
          id: "3",
          name: "产品与需求",
          path: "",
          desc: "企业入驻冲锋衣大数据平台后，可发布产品、需求等信息",
          children: [
            {
              name: "产品中心",
              desc: "企业产品信息发布",
              path: "/productCenter",
            },
            {
              name: "需求发布",
              desc: "企业需求信息发布",
              path: "/demand",
            },
            {
              name: "招工信息",
              desc: "企业招工信息发布",
              path: "/recruit",
            },
          ],
        },
        {
          id: "4",
          name: "公共服务",
          path: "",
          desc: "快速了解冲锋衣产业政策，申请检验检测等服务，查看行业培训视频和相关资料",
          children: [ 
            {
              name: "产业政策",
              desc: "查看冲锋衣产业相关政策",
              path: "/policy",
            },
            {
              name: "检验检测服务",
              desc: "检验设备详细介绍，可申请检测服务",
              path: "/inspectionService",
            },
            {
              name: "T台走秀",
              desc: "综合体T台详细介绍，可申请使用T台",
              path: "/runwayShow",
            },
            {
              name: "培训视频",
              desc: "冲锋衣相关的各类培训视频",
              path: "/video",
            },
            {
              name: "智能制造",
              desc: "介绍冲锋衣产业智能制造情况",
              path: "/intellect",
            },
          ],
        },
       
        {
          id: "5",
          name: "生态与合作",
          path: "",
          desc: "行业内设计大师、专家、合作单位等介绍",
          children: [
            {
              name: "设计大师",
              desc: "行业设计大师介绍",
              path: "/designer",
            },
            {
              name: "专家库",
              desc: "行业管理、营销等专家介绍",
              path: "/expert",
            },
            {
              name: "战略合作单位",
              desc: "战略合作单位介绍",
              path: "/cooperate",
            },
            {
              name: "其他资源",
              desc: "直播电商等产业相关资源",
              path: "/otherResources",
            },
          ],
        },
        {
          id: "6",
          name: "大数据平台",
          // path: "https://datav.aliyuncs.com/share/188b7b81149f4302c5178081c147a565",
          // path:"https://datav.aliyuncs.com/share/62dc94e531bf19033018ed16fb9af9af",
          // path:"https://datav.aliyuncs.com/share/2e31ee2bed2b3dc7979e537de86b6119",
          path:"/dashboard",
          desc: "",
          children: [],
        },
        {
          id: "7",
          name: "联系我们",
          path: "/about",
          desc: "",
          children: [],
        },
      ],
      currentID: "-1",
    };
  },
  methods: {
    // 鼠标经过二级菜单
    mouseover(i) {
      if (i.children.length > 0) {
        this.currentID = i.id;
      } else {
        this.currentID = "-1";
      }
    },
    // 鼠标点击二级菜单
    toLink(obj){

      if(obj){
        this.$router.push({ path: obj.path,  query: { id: obj.id }})
        this.currentID = "-1";
      }
    },
    // 鼠标离开隐藏二级菜单
    mouseleave(){ 
      this.currentID = "-1";
    }
  },
};
</script>
 
<style lang="scss" scoped>
.header-bar {
  position: relative;
  display: flex;
  align-items: center;
  width: 1500px;
  height: 100%;
  margin: auto;
  .logo {
    width: 300px;
    height: 40px;
    margin-right: 80px;
    background: url("../assets/images/logo-white.png") no-repeat center left;
  }
  .nav {
    font-size: 14px;
    line-height: 24px;
    margin: 0px 20px;
    transition: 0.2s;
    a {
      cursor: pointer;
      color: #fff;
    }
    &:hover {
      border-bottom: 1px solid #fff;
    }
    //  子菜单css
    .sub-nav {
      position: absolute;
      display: flex;
      top: 70px;
      left: 50%;
      margin-left:-650px;
      width: 1300px;
      background: #fff;
      box-shadow: 0px 3px 4px rgba(19, 19, 19, 0.08);
      .sub-title {
        width: 320px;
        padding: 40px;
        border-right: 1px solid #f1f1f1;
        flex-shrink: 0;

        h2 {
          font-size: $title-size;
          line-height: 1;
          border-left: 2px solid $primary-color;
          padding-left: 10px;
          margin-bottom: 30px;
        }

        p {
          @include subText;
        }
      }
      .sub-menu {
        display: flex;
        flex-wrap: wrap;
        width: 0px;
        padding: 50px;
        flex-grow: 1;

        .sub-menu-item {
          width: 250px;
          margin-bottom: 30px;
          margin-right: 20px;
          a {
            color: #333333;
            font-size: $title-size;
            font-weight: bold;
            &:hover {
              color: $primary-color !important;
            }
          }
          p {
            @include subText;
          }
        }
      }
      .sub-menu-close {
        position: absolute;
        right: 30px;
        top: 30px;
        font-size: 26px;
        color: $gray-color;
        cursor: pointer;
        &:hover {
          color: $primary-color;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderBox.vue